<template>
    <Select 
        ref="select"
        :value="value"
        @input="(e) => $emit('input',e)"
        class="user-select"
        :class="{'non-searchable': !searchable}"
        :options="options"
        :is-fetching="isFetching"
        :async="async"
        placeholder="Type username..."
        @search-change="(e) => $emit('search-change', e)"
        :filterPredicate="useCustomFiltering ? filterPredicate : undefined"
    >
        <div slot="selected" slot-scope="{selected}" class="label" :class="{'non-searchable': !searchable}">
            <span>{{ removeEmailFromDisplayName(selected.label) }}</span>
            <div class="sublabel">{{ selected.email || extractEmailFromDisplayName(selected.label) }}</div>
        </div>
        <div slot="option" slot-scope="{option}" class="label" :class="{'non-searchable': !searchable}">
            <span>{{ removeEmailFromDisplayName(option.label) }}</span>
            <div class="sublabel">{{ option.email || extractEmailFromDisplayName(option.label) }}</div>
        </div>
    </Select>
</template>

<script>
import { Select } from '@spartez/vue-atlaskit';
import { removeEmailFromDisplayName, extractEmailFromDisplayName } from '../../utils/emailInDisplayName.js';

export default {
    props: {
        value: Object,
        options: Array,
        isFetching: {
            type: Boolean,
            default: false,
        },
        async: {
            type: Boolean,
            default: false
        },
        useCustomFiltering: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: true
        }
    },
    components: {
        Select
    },
    mounted() {
        if(!this.searchable) {
            this.$refs.select.$refs.input.setAttribute("readOnly", true); 
        }
    },
    methods: {
        removeEmailFromDisplayName,
        extractEmailFromDisplayName,
        filterPredicate(val, input) {
            return val.label.toLowerCase().includes(input.toLowerCase().trim()) || val.email.toLowerCase().includes(input.toLowerCase().trim());
        },
    }
}
</script>

<style>
.user-select .input-wrapper:not([is-focused]){
    background-color: #FFFFFF !important;
    border-color: rgba(9, 30, 67, 0.14) !important;
}
.user-select .input-wrapper{
    padding: 10px !important;
}
.non-searchable:hover, .user-select .input-wrapper:hover{
    cursor: pointer;
}
.non-searchable .input-wrapper:is([is-focused]){
    border-color: #dfe1e6 !important;
}
</style>

<style scoped>
.label{
    font-size: 12px;
}

.sublabel{
    font-size: 10px;
    color: #6B778C;
}

.non-searchable:hover{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/users/UserSelect.vue